

import { Skeleton } from "../../../components/ui/skeleton";
import { useEspeceForm } from "../hooks";
import { EspeceFormFields } from "./espece-form-fields";

interface EditEspeceFormProps {
  id: string;
  onCancel: () => void;
  onSuccess: () => void;
}

export function EditEspeceForm({ id, onCancel, onSuccess }: EditEspeceFormProps) {
  const {
    form,
    error,
    isEditing,
    isLoading,
    isSubmitting,
    previewUrl,
    handleImageChange,
    onSubmit,
  } = useEspeceForm({ id, onSuccess });

  if (isLoading) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-8 w-1/3" />
        <div className="space-y-4">
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-20 w-full" />
        </div>
      </div>
    );
  }

  return (
    <EspeceFormFields
      form={form}
      error={error}
      isEditing={isEditing}
      isSubmitting={isSubmitting}
      previewUrl={previewUrl}
      onCancel={onCancel}
      handleImageChange={handleImageChange}
      onSubmit={onSubmit}
    />
  );
}
